var uniqueIdNumber=0;export var getUniqueId=function getUniqueId(){return"react-unique-id-"+uniqueIdNumber++;};